export enum Locales {
  Ru = "Ru",
  Kz = "Kz",
}
